import React from "react";
import { createRoot } from "react-dom/client";
import axios from "../api/axios";
import { uploadCustomAssetRoute } from "../api/routes";
import AssetConflictModal from "../components/AssetConflictModal/AssetConflictModal";

const cloneFormData = (formData) => {
    const nextFormData = new FormData();

    for (const [key, value] of formData.entries()) {
        nextFormData.append(key, value);
    }

    return nextFormData;
};

const resolveAssetConflict = ({ requestedFilename, suggestedFilename }) => {
    return new Promise((resolve) => {
        const host = document.createElement("div");
        document.body.appendChild(host);

        const root = createRoot(host);

        const cleanup = (nextResolution) => {
            root.unmount();
            host.remove();
            resolve(nextResolution);
        };

        root.render(
            <AssetConflictModal
                requestedFilename={requestedFilename}
                suggestedFilename={suggestedFilename}
                onOverwrite={() => cleanup("overwrite")}
                onCreateNew={() => cleanup("createNew")}
            />
        );
    });
};

export const uploadCustomAssetWithConflictResolution = async (formData, config = {}) => {
    const { resolveConflict = resolveAssetConflict, ...requestConfig } = config;

    try {
        return await axios.post(uploadCustomAssetRoute, formData, requestConfig);
    } catch (error) {
        const conflictData = error?.response?.data;
        if (error?.response?.status !== 409 || conflictData?.errorCode !== 'ASSET_EXISTS') {
            throw error;
        }

        const conflictResolution = await resolveConflict(conflictData);
        const retryFormData = cloneFormData(formData);
        retryFormData.set('conflictResolution', conflictResolution);

        if (conflictResolution === 'createNew' && conflictData?.suggestedFilename) {
            retryFormData.set('filename', conflictData.suggestedFilename);
        }

        return axios.post(uploadCustomAssetRoute, retryFormData, requestConfig);
    }
};

export default uploadCustomAssetWithConflictResolution;